// Local Development Configuration
import { readV2PreviewUnlock } from '../utils/v2Preview';

// 🔧 IMPOSTA L'AMBIENTE QUI - Cambia questo valore per cambiare ambiente
const CURRENT_ENVIRONMENT = 'production'; // Valori possibili: 'development', 'labs', 'production'

// Debug: log dell'ambiente corrente
console.log('🌍 Environment set to:', CURRENT_ENVIRONMENT);

/** User ID usato con `npm start` (solo NODE_ENV=development) */
export const DEV_USER_ID = 3;

/**
 * Utente finto usato con `npm start` (solo NODE_ENV=development): è l'unico punto da cambiare per provare un ruolo.
 * role_id: 1 Admin, 2 Team Member, 3 Service Manager, 4 JR Service Manager, 5 Team Leader, 6 People Manager, 7 Delivery Manager.
 * org_role_id: 2 = People Manager (accesso alle pagine "My people"), 1 = nessuna gerarchia.
 */
export const DEV_USER = {
  id: DEV_USER_ID,
  name: 'Developer',
  username: 'devuser',
  email: 'dev@example.com',
  surname: 'User',
  role_id: 1,
  org_role_id: 1,
};

export const LOCAL_CONFIG = {
  // Cognito Configuration per tre ambienti: development, labs, production
  COGNITO: (() => {
    switch (CURRENT_ENVIRONMENT) {
      case 'development':
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'your-cognito-domain.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || 'your-client-id',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
      case 'labs':
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'eu-west-1qnfy3xnde.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '74f5mgp979ueq4qepgm8ftsdli',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
      case 'production':
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'eu-west-1akjphjw2s.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '5iummgtnggp6aeamiolek1n10m',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
      default:
        // Default a labs se l'ambiente non è riconosciuto
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'eu-west-1qnfy3xnde.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '74f5mgp979ueq4qepgm8ftsdli',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
    }
  })(),
  
  // API Configuration for Local Development
  API: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001'
  },
  
  // Redirect URLs per tre ambienti: development, labs, production
  REDIRECT_URLS: {
    login: (() => {
      switch (CURRENT_ENVIRONMENT) {
        case 'development':
          return 'http://localhost:3000';
        case 'labs':
          return 'https://runtimesheet.labs.avvale.com';
        case 'production':
          return 'https://runtimesheet.avvale.com';
        default:
          return 'https://runtimesheet.labs.avvale.com'; // Default a labs
      }
    })(),
    logout: (() => {
      switch (CURRENT_ENVIRONMENT) {
        case 'development':
          return 'http://localhost:3000';
        case 'labs':
          return 'https://runtimesheet.labs.avvale.com';
        case 'production':
          return 'https://runtimesheet.avvale.com';
        default:
          return 'https://runtimesheet.labs.avvale.com'; // Default a labs
      }
    })()
  },
  
  // OIDC Configuration per tre ambienti: development, labs, production
  OIDC: (() => {
    switch (CURRENT_ENVIRONMENT) {
      case 'development':
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/your-pool-id",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "your-client-id",
          redirect_uri: "http://localhost:3000",
          response_type: "code",
          scope: "email openid phone"
        };
      case 'labs':
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_qNFY3xNde",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "3lletgh4vquih40po07ed906fg",
          redirect_uri: "https://runtimesheet.labs.avvale.com",
          response_type: "code",
          scope: "email openid phone"
        };
      case 'production':
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_aKJphjW2S",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "5iummgtnggp6aeamiolek1n10m",
          redirect_uri: "https://runtimesheet.avvale.com",
          response_type: "code",
          scope: "email openid phone"
        };
      default:
        // Default a labs se l'ambiente non è riconosciuto
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_qNFY3xNde",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "3lletgh4vquih40po07ed906fg",
          redirect_uri: "https://runtimesheet.labs.avvale.com",
          response_type: "code",
          scope: "email openid phone"
        };
    }
  })(),

  // Feature flags per ambiente (Contract / Report Mapping)
  FEATURES: (() => {
    switch (CURRENT_ENVIRONMENT) {
      case 'production':
        return {
          ENABLE_TAB_CONTRACT: false,
          ENABLE_TAB_MAPPING: true,
          ENABLE_HOME_V2: true,
          ENABLE_MONTHLY_MNG_VIEW_V2: true,
          ENABLE_MONTHLY_PM_VIEW_V2: true,
          ENABLE_COMPACT_SHELL: true,
          ENABLE_DAILY_TRACKING_V2: true,
          ENABLE_NEW_SIDEBAR: true,
          ENABLE_WORKLOGS_V2: true,
          ENABLE_USERS_V2: true,
          ENABLE_MY_MONTH_V2: true,
          ENABLE_CUSTOMERS_V2: true,
          ENABLE_PROJECTS_V2: true,
          ENABLE_PROFILE_V2: true,
          ENABLE_ACTIVITIES_V2: true,
          ENABLE_CONTRACTS_V2: false,
          ENABLE_V2_UNLOCK_LINK: false,
        };
      case 'labs':
        return {
          ENABLE_TAB_CONTRACT: true,
          ENABLE_TAB_MAPPING: true,
          ENABLE_HOME_V2: true,
          ENABLE_MONTHLY_MNG_VIEW_V2: true,
          ENABLE_MONTHLY_PM_VIEW_V2: true,
          ENABLE_COMPACT_SHELL: true,
          ENABLE_DAILY_TRACKING_V2: true,
          ENABLE_NEW_SIDEBAR: true,
          ENABLE_WORKLOGS_V2: true,
          ENABLE_USERS_V2: true,
          ENABLE_MY_MONTH_V2: true,
          ENABLE_CUSTOMERS_V2: true,
          ENABLE_PROJECTS_V2: true,
          ENABLE_PROFILE_V2: true,
          ENABLE_ACTIVITIES_V2: true,
          ENABLE_CONTRACTS_V2: true,
          ENABLE_V2_UNLOCK_LINK: false,
        };
      case 'development':
      default:
        return {
          ENABLE_TAB_CONTRACT: true,
          ENABLE_TAB_MAPPING: true,
          ENABLE_HOME_V2: true,
          ENABLE_MONTHLY_MNG_VIEW_V2: true,
          ENABLE_MONTHLY_PM_VIEW_V2: true,
          ENABLE_COMPACT_SHELL: true,
          ENABLE_DAILY_TRACKING_V2: true,
          ENABLE_NEW_SIDEBAR: true,
          ENABLE_WORKLOGS_V2: true,
          ENABLE_USERS_V2: true,
          ENABLE_MY_MONTH_V2: true,
          ENABLE_CUSTOMERS_V2: true,
          ENABLE_PROJECTS_V2: true,
          ENABLE_PROFILE_V2: true,
          ENABLE_ACTIVITIES_V2: true,
          ENABLE_CONTRACTS_V2: true,
          ENABLE_V2_UNLOCK_LINK: false,
        };
    }
  })(),

};

// Novità grafiche (pagine V2, sidebar nuova, shell compatta): con ENABLE_V2_UNLOCK_LINK restano spente
// finché in questo browser non si apre il link di sblocco (?preview=v2; ?preview=off le rispegne)
const V2_FEATURES = ['ENABLE_HOME_V2', 'ENABLE_MONTHLY_MNG_VIEW_V2', 'ENABLE_MONTHLY_PM_VIEW_V2', 'ENABLE_COMPACT_SHELL', 'ENABLE_DAILY_TRACKING_V2', 'ENABLE_NEW_SIDEBAR', 'ENABLE_WORKLOGS_V2', 'ENABLE_USERS_V2', 'ENABLE_MY_MONTH_V2', 'ENABLE_CUSTOMERS_V2', 'ENABLE_PROJECTS_V2', 'ENABLE_CONTRACTS_V2', 'ENABLE_ACTIVITIES_V2', 'ENABLE_PROFILE_V2'];
const V2_LOCKED = LOCAL_CONFIG.FEATURES.ENABLE_V2_UNLOCK_LINK && !readV2PreviewUnlock();
const FEATURES = V2_LOCKED ? { ...LOCAL_CONFIG.FEATURES, ...Object.fromEntries(V2_FEATURES.map((flag) => [flag, false])) } : LOCAL_CONFIG.FEATURES;

export const { ENABLE_TAB_CONTRACT, ENABLE_TAB_MAPPING, ENABLE_HOME_V2, ENABLE_MONTHLY_MNG_VIEW_V2, ENABLE_MONTHLY_PM_VIEW_V2, ENABLE_COMPACT_SHELL, ENABLE_DAILY_TRACKING_V2, ENABLE_NEW_SIDEBAR, ENABLE_WORKLOGS_V2, ENABLE_USERS_V2, ENABLE_MY_MONTH_V2, ENABLE_CUSTOMERS_V2, ENABLE_PROJECTS_V2, ENABLE_CONTRACTS_V2, ENABLE_ACTIVITIES_V2, ENABLE_PROFILE_V2 } = FEATURES;

// Helper function to check if running locally
export const isLocalDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// Helper function to check if running in labs environment
export const isLabsEnvironment = () => {
  return process.env.NODE_ENV === 'labs';
};

// Helper function to check if running in production environment
export const isProductionEnvironment = () => {
  return process.env.NODE_ENV === 'production';
};

// Helper function to get current environment
export const getCurrentEnvironment = () => {
  return CURRENT_ENVIRONMENT; // Ritorna l'ambiente configurato in questo file
};

// Helper function to get the appropriate redirect URI
export const getRedirectUri = () => {
  return LOCAL_CONFIG.REDIRECT_URLS.login;
};

  // Helper function to get the appropriate logout URI
export const getLogoutUri = () => {
  return LOCAL_CONFIG.REDIRECT_URLS.logout;
};

// Support Configuration
export const SUPPORT_CONFIG = {
  email: 'runtimeapp-support@avvale-services.atlassian.net'
};

// Working Days Configuration
export const WORKING_DAYS_CONFIG = {
  // Numero di giorni lavorativi dopo l'inizio del mese per permettere l'editing del mese precedente
  // Valori possibili: 1, 2, 3, 4, 5, 10, etc.
  // 1 = solo il primo giorno lavorativo del mese
  // 5 = primi 5 giorni lavorativi del mese
  // 10 = primi 10 giorni lavorativi del mese
  previousMonthEditingDays: 31,
  
  // Giorni della settimana considerati lavorativi (0 = domenica, 1 = lunedì, ..., 6 = sabato)
  // Esempi:
  // [1, 2, 3, 4, 5] = Lunedì-Venerdì (standard)
  // [1, 2, 3, 4, 5, 6] = Lunedì-Sabato (incluso sabato)
  // [1, 2, 3, 4, 5, 6, 0] = Tutti i giorni della settimana
  // [1, 3, 5] = Solo Lunedì, Mercoledì, Venerdì
  workingDaysOfWeek: [1, 2, 3, 4, 5], // Lunedì-Venerdì
  
  // Nome dei giorni per debug/logging
  dayNames: {
    0: 'Sunday',
    1: 'Monday', 
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  }
};

// Home V2: obiettivi giornalieri usati per KPI e calendario
export const HOME_CONFIG = {
  dailyTargetHours: 8,
  // Ore scalate dall'obiettivo giornaliero in caso di assenza parziale
  partialAbsenceHours: 4,
};

export const FORECAST_CONFIG = {
  activityName: 'FORECAST',
  forecastCellColor: '#1976d2',
  forecastCellBg: '#e3f2fd',
  editableHighlightBg: '#fff3e0',
  maxHoursPerDay: 8,
};